import { createFileRoute, Outlet } from '@tanstack/react-router'
import AdminLayoutPage from '@/layouts/AdminLayout/AdminLayout'

export const Route = createFileRoute('/$workspaceName/$environment/admin')({
  component: AdminLayoutRoute,
})

function AdminLayoutRoute() {
  return (
    <AdminLayoutPage>
      <Outlet />
    </AdminLayoutPage>
  )
}
